import React, {useEffect} from 'react';
import NProgress from 'nprogress';
import { makeStyles } from '@material-ui/core';
import { Spinner } from '../Loaders';


const useStyles = makeStyles((theme) => ({
  root: {
    padding:"48px 0px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // backgroundColor: theme.palette.background.default,
    height: '100%',
    justifyContent: 'center',
  }
}));


function LoadingScreen() {
  const classes = useStyles();

  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div className={classes.root}>

        {/* <LinearProgress /> */}
        <Spinner />
    </div>
  );
}

export default LoadingScreen;